<!--- [Web App] -->
<div *ngIf="!isCordova">
  <itl-info-box class="box-signopad-notready" [type]="warningType" *ngIf="!readyForSignature">
    {{ 'audit.node.signature.signoPadNotReady' | translate }}</itl-info-box
  >
  <div class="signature-item">
    <div class="signature-item--icon">
      <ion-icon name="alberta-signature"></ion-icon>
    </div>
    <div class="signature-item--content">
      <div [ngClass]="node.mandatory ? 'text-container required-star':'text-container'">
        <div class="text">{{ node.title }} <span *ngIf="node.mandatory">*</span></div>
      </div>
      <img [src]="signatureImage?.data" *ngIf="signatureImage" />
      <itl-button class="button-signature" [disabled]="!readyForSignature" (click)="signWithSignopad()">
        {{ 'audit.node.signature.signWithSignopad' | translate | uppercase }}
      </itl-button>
      <itl-button class="button-signature" (click)="signWithBrowserSignaturePad()">
        {{ 'audit.node.signature.signInBrowser' | translate | uppercase }}
      </itl-button>
    </div>
  </div>
</div>
<!-- [END Web App] -->
<!-- [Cordova Fallback] -->
<div *ngIf="isCordova">
  <div class="signature-item">
    <div class="signature-item--icon">
      <ion-icon name="alberta-signature"></ion-icon>
    </div>
    <div class="signature-item--content">
      <div [ngClass]="node.mandatory ? 'text-container required-star':'text-container'">
        <div class="text">{{ node.title }} <span *ngIf="node.mandatory">*</span></div>
      </div>
      <img [src]="signatureImage?.data" *ngIf="signatureImage" />
      <itl-button class="button-signature" (click)="signWithBrowserSignaturePad()">
        {{ 'audit.node.signature.sign' | translate | uppercase }}
      </itl-button>
    </div>
  </div>
</div>
<!-- [END Cordova Fallback] -->
